import api from "../../api/index";

const fetchalldevices = `${process.env.VUE_APP_BASE_URI}/devices`;
const exportdevices = `${process.env.VUE_APP_BASE_URI}/report/download-device-report`;
const fetchpoi = `${process.env.VUE_APP_BASE_URI}/point-of-interests`;
const fetchgeofence = `${process.env.VUE_APP_BASE_URI}/geofence`;
const fetchtempstats = `${process.env.VUE_APP_BASE_URI}/stats/temperature`;
const fetchhumistats = `${process.env.VUE_APP_BASE_URI}/stats/humidity`;
const fetchdevicedetails = `${process.env.VUE_APP_BASE_URI}/devices`;
const updatedevice = `${process.env.VUE_APP_BASE_URI}/devices`;
const adddevice = `${process.env.VUE_APP_BASE_URI}/devices/setup`;
const getdevicehistory = `${process.env.VUE_APP_BASE_URI}/getDeviceHistory`;
const addlicense = `${process.env.VUE_APP_BASE_URI}/device`;
const turnoffdevice = `${process.env.VUE_APP_BASE_URI}/power`;
const viewsubscription = `${process.env.VUE_APP_BASE_URI}/license`;
const swapdevice = `${process.env.VUE_APP_BASE_URI}/devices/swap`;
const deviceExcursions = `${process.env.VUE_APP_BASE_URI}/excursions`;
const getDeviceStats = `${process.env.VUE_APP_BASE_URI}/getDeviceStats`;
const getDeviceReportByEmail = `${process.env.VUE_APP_BASE_URI}/device/report`;

// Device Sessions Endpoints
const deviceSessions = `${process.env.VUE_APP_BASE_URI}/device-sessions`;
const deviceSessionsCount = `${process.env.VUE_APP_BASE_URI}/device-sessions/count`;
const deviceSessionsHistory = `${process.env.VUE_APP_BASE_URI}/device-sessions/history`;

const getDefaultState = () => {
  return {
    devices: [],
    singledevice: {},
    tempstats: [],
    humistats: [],
    POI: [],
    geofence: [],
    devicehistory: [],
    subscription: [],
    status: "",
    deviceexcursions: {},
    paginationMeta: {},
    poiMeta: {},
    geofenceMeta: {},
    devicesSummary: {},
    deviceExcursionSummary: {
      // humOverview: {
      //   excursions: [],
      //   excursionCount: 0,
      //   average: "00hrs 00mins ",
      //   highest: "00hrs 00mins ",
      //   lowest: "00hrs 00mins ",
      //   maxtemp: 100,
      //   mintemp: 0,
      // },
      // tempOverview: {
      //   excursions: [
      //     {
      //       temperature: 27.7,
      //       minTemperature: 6,
      //       maxTemperature: 15,
      //       deviceTimeStamp: "2023-10-18T12:55:39.000Z",
      //       start: "2023-10-18T12:55:39.000Z",
      //       duration: 1070133000,
      //       lastExcursionTimeStamp: "2023-10-30T22:11:12.000Z",
      //       end: null,
      //     },
      //   ],
      //   excursionCount: 1,
      //   average: "297hrs 15mins ",
      //   highest: "297hrs 15mins ",
      //   lowest: "297hrs 15mins ",
      //   maxtemp: 30.2,
      //   mintemp: 6,
      // },
      // humidityReports: [],
      // temperatureReports: [
      //   {
      //     temperature: 27.7,
      //     minTemperature: 6,
      //     maxTemperature: 15,
      //     deviceTimeStamp: "2023-10-18T12:55:39.000Z",
      //     start: "2023-10-18T12:55:39.000Z",
      //     duration: 1070133000,
      //     lastExcursionTimeStamp: "2023-10-30T22:11:12.000Z",
      //     end: null,
      //   },
      //   {
      //     temperature: 27.7,
      //     minTemperature: 6,
      //     maxTemperature: 15,
      //     deviceTimeStamp: "2023-10-18T12:55:39.000Z",
      //     start: "2023-10-18T12:55:39.000Z",
      //     duration: 1070133000,
      //     lastExcursionTimeStamp: "2023-10-30T22:11:12.000Z",
      //     end: null,
      //   },
      // ],
    },
    devicehistoryChart: [],
    devicehistoryMapPoints: {},
    condition: "",
    sessions: [],
    sessionsCount: 0,
    sessionHistory: [],
    selectedSession: null,
    historyMeta: {},
  };
};

const state = getDefaultState();

const getters = {
  devices: (state) => state.devices,
  devicespaginationMeta: (state) => state.paginationMeta,
  singledevice: (state) => state.singledevice,
  tempstats: (state) => state.tempstats,
  humistats: (state) => state.humistats,
  POI: (state) => state.POI,
  geofence: (state) => state.geofence,
  devicehistory: (state) => state.devicehistory,
  subscription: (state) => state.subscription,
  deviceexcursions: (state) => state.deviceexcursions,
  poiMeta: (state) => state.poiMeta,
  geofenceMeta: (state) => state.geofenceMeta,
  devicesSummary: (state) => state.devicesSummary,
  deviceExcursionSummary: (state) => state.deviceExcursionSummary,
  devicehistoryChart: (state) => state.devicehistoryChart,
  devicehistoryMapPoints: (state) => state.devicehistoryMapPoints,

  getCondition: (state) => state.condition,
  sessions: (state) => state.sessions,
  sessionsCount: (state) => state.sessionsCount,
  sessionHistory: (state) => state.sessionHistory,
  selectedSession: (state) => state.selectedSession,
  historyMeta: (state) => state.historyMeta,
};

const actions = {
  async fetchallDevices({ commit }, params) {
    commit("fetchall_request");
    const res = await api.get(fetchalldevices, {
      params,
    });
    if (res.data.success) {
      commit("fetchall_success", res.data.payload);
      //console.log(res.data.devices, "device3")
    }
    return res;
  },

  async fetchSearchedDevices({ commit }, params) {
    commit("fetchall_request");
    const res = await api.get(`${fetchalldevices}`, {
      params,
    });
    if (res.data.success) {
      commit("fetchall_success", res.data.payload);
    }
    return res;
  },
  async exportDevices({ commit }, params) {
    commit("exportdevices_request");
    const res = await api.post(`${exportdevices}`, params);
    if (res.data.success) {
      commit("exportdevices_success", res.data.payload);
    } else {
      commit("exportdevices_error", res.data.message);
    }
    return res;
  },
  async fetchDeviceStats({ commit }, period) {
    commit("fetchall_request");
    const res = await api.post(`${getDeviceStats}`, period);
    return res;
  },
  async fetchTempStats({ commit }, { device_imei }) {
    commit("fetchtempstats_request");
    const res = await api.get(`${fetchtempstats}/${device_imei}`);
    if (res.data.success) {
      commit("fetchtempstats_success", res.data.stats);
    }
    return res;
  },
  async fetchCustomTempStats({ commit }, { device_imei, period }) {
    commit("fetchcustomtempstats_request");
    const res = await api.post(`${fetchtempstats}/${device_imei}`, period);
    if (res.data.success) {
      commit("fetchcustomtempstats_success", res.data.stats);
    }
    return res;
  },
  async fetchHumiStats({ commit }, { device_imei }) {
    commit("fetchhumistats_request");
    const res = await api.get(`${fetchhumistats}/${device_imei}`);
    if (res.data.success) {
      commit("fetchhumistats_success", res.data.stats);
    }
    return res;
  },
  async fetchCustomHumiStats({ commit }, { device_imei, period }) {
    commit("fetchcustomhumistats_request");
    const res = await api.post(`${fetchhumistats}/${device_imei}`, period);
    if (res.data.success) {
      commit("fetchcustomhumistats_success", res.data.stats);
    }
    return res;
  },
  async fetchPOI({ commit }) {
    commit("fetchPOI_request");
    const res = await api.get(fetchpoi);
    if (res.data.success) {
      commit("fetchPOI_success", res.data.payload);
    }
    return res;
  },
  async fetchPOIByID({ commit }, id) {
    commit("fetchPOI_request");
    const res = await api.get(`${fetchpoi}/${id}`);
    if (res.data.success) {
      commit("fetchPOI_success", res.data.payload);
    }
    return res;
  },
  async addPOI({ commit }, { POI }) {
    commit("addPOI_request");
    const res = await api.post(fetchpoi, POI);
    if (res.data.success) {
      commit("addPOI_success");
    }
    return res;
  },
  async editpoi({ commit }, { POI, id }) {
    commit("addPOI_request");
    const res = await api.patch(`${fetchpoi}/${id}`, POI);
    if (res.data.success) {
      commit("addPOI_success");
    }
    return res;
  },
  async deletePOI({ commit }, id) {
    commit("deletePOI_request");
    const res = await api.delete(`${fetchpoi}/${id}`);
    if (res.data.success) {
      commit("deletePOI_success");
    }
    return res;
  },
  async deleteGeofence({ commit }, id) {
    commit("deletegeofence_request");
    const res = await api.delete(`${fetchgeofence}/${id}`);
    if (res.data.success) {
      commit("deletegeofence_success");
    }
    return res;
  },
  async fetchGeofence({ commit }) {
    commit("fetchgeofence_request");
    const res = await api.get(fetchgeofence);
    if (res.data.success) {
      commit("fetchgeofence_success", res.data.payload);
    }
    return res;
  },
  async addGeofenceAPI({ commit }, { geofence }) {
    commit("addgeofence_request");
    const res = await api.post(fetchgeofence, geofence);
    if (res.data.success) {
      commit("addgeofence_success");
    }
    return res;
  },
  async editGeofenceAPI({ commit }, { geofence, id }) {
    commit("addgeofence_request");
    const res = await api.patch(`${fetchgeofence}/${id}`, geofence);
    if (res.data.success) {
      commit("addgeofence_success");
    }
    return res;
  },
  async fetchDeviceDetails({ commit }, { device_id }) {
    commit("fetchdetails_request");
    const res = await api.get(`${fetchdevicedetails}/${device_id}`);
    if (res.data.success) {
      commit("fetchdetails_success", res.data.payload);
    }
    return res;
  },
  async updateDevice({ commit }, { device_id, deviceupdate }) {
    commit("updatedevice_request");
    const res = await api.patch(`${updatedevice}/${device_id}`, deviceupdate);
    if (res.data.success) {
      commit("updatedevice_success");
    }
    return res;
  },
  async getDeviceHistory({ commit }, { period, params }) {
    commit("gethistory_request");
    const res = await api.get(`${fetchalldevices}/${period.device}/history`, {
      params,
    });
    if (res.data.success) {
      commit("gethistory_success", res.data.payload);
    }
    return res;
  },
  async getDeviceHistoryChart({ commit }, { period, params }) {
    commit("gethistory_chart_request");
    const res = await api.get(
      `${fetchalldevices}/${period.device}/history/chart`,
      {
        params,
      }
    );
    if (res.data.success) {
      commit("gethistory_chart_success", res.data.payload);
    }
    return res;
  },
  async getDeviceHistoryMapPoints({ commit }, { period, params }) {
    const res = await api.get(
      `${fetchalldevices}/${period.device}/history/map-points`,
      {
        params,
      }
    );
    if (res.data.success) {
      commit("gethistory_map_points_success", res.data.payload);
    }
    return res;
  },

  async getDeviceReportByEmail({ commit }, { data, id }) {
    const res = await api.post(`${fetchalldevices}/${id}/history/report`, data);
    return res;
  },

  async addDevice({ commit }, newdevice) {
    commit("adddevice_request");
    const res = await api.post(adddevice, newdevice);
    if (res.data.success) {
      commit("adddevice_success");
    }
    return res;
  },

  async addLicense({ commit }, licensekey) {
    //console.log(licensekey);
    commit("addlicense_request");
    const res = await api.patch(addlicense, licensekey);
    if (res.data.success) {
      commit("addlicense_success");
    }
    return res;
  },

  async turnOffDevice({ commit }, deviceTag) {
    //console.log(licensekey);
    commit("turnoffdevice_request");
    const res = await api.put(turnoffdevice, deviceTag);
    if (res.data.success) {
      commit("turnoffdevice_success");
    }
    return res;
  },

  async viewSubscription({ commit }, { licensekey }) {
    //console.log(licensekey);
    commit("viewsubscription_request");
    const res = await api.get(`${viewsubscription}/${licensekey}`);
    if (res.data.success) {
      commit("viewsubscription_success", res.data.payload);
    }
    return res;
  },

  async swapDevice({ commit }, { imei, imei_id }) {
    commit("swapdevice_request");
    const res = await api.post(
      `${fetchalldevices}/${imei_id}/swap`,
      { newImei: imei },
      { params: { id: imei_id } }
    );
    if (res.data.success) {
      commit("swapdevice_success");
    }
    return res;
  },

  async fetchDeviceExcursions({ commit }, { params }) {
    commit("fetchexcursions_request");
    const res = await api.get(`${deviceExcursions}`, {
      params,
    });
    // const res = await api.get(`${deviceExcursions}/${device_imei}`, {
    //   params,
    // });
    if (res.data.success) {
      commit("fetchexcursions_success", res.data.payload);
    }
    return res;
  },

  async fetchDevicesSummary({ commit }) {
    const res = await api.get(`${fetchalldevices}/summary`);
    if (res.data.success) {
      commit("fetch_device_summary_success", res.data.payload);
    }
    return res;
  },
  async fetchExcursionSummary({ commit }, { id, params }) {
    commit("fetch_excursion_summary_request");
    const res = await api.get(`${fetchalldevices}/${id}/excursion/summary`, {
      params,
    });
    if (res.data.success) {
      commit("fetch_excursion_summary_success", res.data.payload);
    }
    return res;
  },
  async fetchDeviceExcursion({ commit }, id) {
    commit("fetch_excursion_summary_request");
    const res = await api.get(`${fetchalldevices}/${id}/excursion`);
    return res;
  },

  async updateFlightMode({ commit }, { device_id, flightMode }) {
    commit("updateflightmode_request");
    const res = await api.patch(
      `${fetchalldevices}/${device_id}/flight-mode`,
      flightMode
    );
    if (res.data.success) {
      commit("updateflightmode_success");
    }
    return res;
  },
  async updateFlightModeDirect({ commit }, { device_id, flightMode }) {
    const res = await api.patch(
      `${fetchalldevices}/${device_id}/flight-mode-direct`,
      flightMode
    );
    if (res.data.success) {
      commit("updateflightmode_success");
    }
    return res;
  },

  async fetchFlightSchedule(
    { commit },
    { device_id, carrierCode, flightNumber, scheduledDepartureDate }
  ) {
    commit("fetchflightschedule_request");
    const res = await api.get(
      `${fetchalldevices}/${device_id}/flight-schedule`,
      {
        params: {
          carrierCode,
          flightNumber,
          scheduledDepartureDate,
        },
      }
    );
    if (res.data.success) {
      commit("fetchflightschedule_success", res.data.payload);
    }
    return res;
  },

  async correctGoogleMapLocation({ commit }, { locations }) {
    commit("correctgooglemaplocation_request");
    const res = await api.post(
      `https://map-corrections.backend.figorr.com/process-locations`,
      locations
    );
    return res;
  },

  async resetDevicesState({ commit }) {
    await commit("resetdevicesstate_success");
  },
  async resetDeviceHistory({ commit }) {
    await commit("resetDeviceHistory_success");
  },
  async resetHistoryChart({ commit }) {
    await commit("resetDeviceHistoryChart_success");
  },

  async setCondition({ commit }, condition) {
    commit("set_condition", condition);
  },
  async clearCondition({ commit }) {
    commit("clear_condition");
  },
  async createSession({ commit }, payload) {
    commit("create_session_request");
    const res = await api.post(deviceSessions, payload);
    if (res.data.success) commit("create_session_success");
    return res;
  },

  async fetchSessions({ commit }, params) {
    commit("fetch_sessions_request");
    const res = await api.get(deviceSessions, { params });
    if (res.data.success) commit("fetch_sessions_success", res.data.payload);
    return res;
  },

  async fetchSessionsCount({ commit }) {
    const res = await api.get(deviceSessionsCount);
    if (res.data.success)
      commit("fetch_sessions_count_success", res.data.payload.total);
    return res;
  },

  async fetchSessionHistory({ commit }, params) {
    commit("fetch_session_history_request");
    const res = await api.get(deviceSessionsHistory, { params });
    if (res.data.success)
      commit("fetch_session_history_success", res.data.payload);
    return res;
  },
  async setSelectedSession({ commit }, session) {
    commit("SET_SELECTED_SESSION", session);
  },
  async clearSelectedSession({ commit }) {
    commit("CLEAR_SELECTED_SESSION");
  },
};

const mutations = {
  fetchall_request: (state) => (state.status = "loading"),
  fetchall_success: (state, data) => {
    state.status = "success";
    state.devices = data.data;
    state.paginationMeta = data.meta;
  },
  exportdevices_request: (state) => (state.status = "loading"),
  exportdevices_success: (state, data) => {
    state.status = "success";
    state.exportdevices = data.payload;
  },
  exportdevices_error: (state, error) => {
    state.status = "error";
    state.error = error;
  },
  fetchhumistats_request: (state) => (state.status = "loading"),
  fetchhumistats_success: (state, data) => {
    state.status = "success";
    state.humistats = data;
  },
  fetchcustomhumistats_request: (state) => (state.status = "loading"),
  fetchcustomhumistats_success: (state, data) => {
    state.status = "success";
    state.humistats = data;
  },
  fetchPOI_request: (state) => (state.status = "loading"),
  fetchPOI_success: (state, data) => {
    state.status = "success";
    state.POI = data.data;
    state.poiMeta = data.meta;
  },
  fetchgeofence_request: (state) => (state.status = "loading"),
  fetchgeofence_success: (state, data) => {
    state.status = "success";
    state.geofence = data.data;
    state.geofenceMeta = data.meta;
  },
  deletePOI_request: (state) => (state.status = "loading"),
  deletePOI_success: (state) => (state.status = "success"),
  deletegeofence_request: (state) => (state.status = "loading"),
  deletegeofence_success: (state) => (state.status = "success"),
  fetchdetails_request: (state) => (state.status = "loading"),
  fetchdetails_success: (state, data) => {
    state.status = "success";
    state.singledevice = data;
  },
  updatedevice_request: (state) => (state.status = "loading"),
  updatedevice_success: (state) => {
    state.status = "success";
  },
  addPOI_request: (state) => (state.status = "loading"),
  addPOI_success: (state) => {
    state.status = "success";
  },
  addgeofence_request: (state) => (state.status = "loading"),
  addgeofence_success: (state) => {
    state.status = "success";
  },
  adddevice_request: (state) => (state.status = "loading"),
  adddevice_success: (state) => {
    state.status = "success";
  },
  addlicense_request: (state) => (state.status = "loading"),
  addlicense_success: (state) => {
    state.status = "success";
  },
  gethistory_request: (state) => (state.status = "loading"),
  gethistory_success: (state, devicehistory) => {
    state.status = "success";
    state.devicehistory = devicehistory;
  },
  gethistory_chart_success: (state, devicehistoryChart) => {
    state.status = "success";
    // state.devicehistoryChart = devicehistoryChart;
  },
  gethistory_map_points_success: (state, devicehistoryMapPoints) => {
    state.status = "success";
    state.devicehistoryMapPoints = devicehistoryMapPoints;
  },
  turnoffdevice_request: (state) => (state.status = "loading"),
  turnoffdevice_success: (state) => {
    state.status = "success";
  },
  viewsubscription_request: (state) => (state.status = "loading"),
  viewsubscription_success: (state, subscription) => {
    state.status = "success";
    state.subscription = subscription;
  },
  fetchexcursions_request: (state) => (state.status = "loading"),
  fetchexcursions_success: (state, data) => {
    state.status = "success";
    state.deviceexcursions = data;
  },
  fetch_device_summary_success: (state, data) => {
    state.devicesSummary = data;
  },
  fetch_excursion_summary_success: (state, data) => {
    state.deviceExcursionSummary = data;
  },
  resetdevicesstate_success: (state) => Object.assign(state, getDefaultState()),
  resetDeviceHistory_success: (state) => {
    state.devicehistory = [];
    state.devicehistoryChart = [];
    state.devicehistoryMapPoints = {};
  },
  resetDeviceHistoryChart_success: (state) => (state.devicehistoryChart = []),

  set_condition: (state, condition) => (state.condition = condition),
  clear_condition: (state) => (state.condition = ""),
  create_session_request: (state) => (state.status = "loading"),
  create_session_success: (state) => (state.status = "success"),

  fetch_sessions_request: (state) => (state.status = "loading"),
  fetch_sessions_success: (state, data) => {
    state.status = "success";
    state.sessions = data;
  },

  fetch_sessions_count_success: (state, count) => {
    state.sessionsCount = count;
  },

  fetch_session_history_request: (state) => (state.status = "loading"),
  fetch_session_history_success: (state, data) => {
    state.status = "success";
    state.sessionHistory = data;
    state.historyMeta = data.meta;
  },
  SET_SELECTED_SESSION(state, session) {
    state.selectedSession = session;
  },
  CLEAR_SELECTED_SESSION(state) {
    state.selectedSession = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
